import { render, staticRenderFns } from "./Qr.vue?vue&type=template&id=18495f08&scoped=true"
import script from "./Qr.vue?vue&type=script&lang=js"
export * from "./Qr.vue?vue&type=script&lang=js"
import style0 from "./Qr.vue?vue&type=style&index=0&id=18495f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18495f08",
  null
  
)

export default component.exports